import { render, staticRenderFns } from "./PobList.vue?vue&type=template&id=b727081c&scoped=true&"
import script from "./PobList.vue?vue&type=script&lang=js&"
export * from "./PobList.vue?vue&type=script&lang=js&"
import style0 from "./PobList.vue?vue&type=style&index=0&id=b727081c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b727081c",
  null
  
)

export default component.exports